module.exports = __webpack_public_path__ + "img/CtrlRoom_sleep_on.3eed5bf3.png";